module.exports = __webpack_public_path__ + "static/media/user.2369d24d.svg";